import { RouteRecordRaw } from 'vue-router'

const authenticatedRoutes: Array<RouteRecordRaw> = []

export default authenticatedRoutes
